import logoSpec from '../../assets/images/cruisingos_logo_package_clean/docs/logo_spec.json';

// The supplied logo is the source of the interface accent, including Mantine
// and older styled-components controls. Domain/map palettes stay independent.
const mix = (from, to, amount) => `#${[1, 3, 5].map(offset => {
  const a = parseInt(from.slice(offset, offset + 2), 16);
  const b = parseInt(to.slice(offset, offset + 2), 16);
  return Math.round(a + (b - a) * amount).toString(16).padStart(2, '0');
}).join('')}`;

export const brand = {
  teal: logoSpec.colors.teal,
  navy: logoSpec.colors.navy,
  hover: mix(logoSpec.colors.teal, logoSpec.colors.navy, 0.12),
  selected: mix(logoSpec.colors.teal, '#ffffff', 0.90),
};

export const cruisePalette = [
  brand.selected,
  ...[0.80, 0.60, 0.40, 0.20].map(amount => mix(brand.teal, '#ffffff', amount)),
  brand.teal, brand.hover,
  ...[0.25, 0.40, 0.55].map(amount => mix(brand.teal, brand.navy, amount)),
];
